import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Jira = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <g id="jira_logo_gradient_blue_jira">
      <g id="jira_Icon">
        <path
          id="jira_Vector"
          fill="hsl(from hsl(217 100% 58%) h s 51%)"
          d="M21.4,2.1h-10c0,2.4,2,4.4,4.5,4.4h1.8v1.7c0,2.4,2,4.4,4.5,4.4V3C22.3,2.5,21.9,2.1,21.4,2.1z"
        />
        <linearGradient
          id="jira_Vector_2_1_"
          gradientUnits="userSpaceOnUse"
          x1="16.9669"
          y1="19.1932"
          x2="12.8489"
          y2="14.8208"
          gradientTransform="matrix(1 0 0 -1 0 26)"
        >
          <stop
            offset="0.176"
            stopColor="hsl(from hsl(217 100% 58%) h s 32%)"
          />
          <stop offset="1" stopColor="hsl(from hsl(217 100% 58%) h s 51%)" />
        </linearGradient>
        <path
          id="jira_Vector_2"
          fill="url(#jira_Vector_2_1_)"
          d="M16.5,6.9h-10c0,2.4,2,4.4,4.5,4.4h1.8V13c0,2.4,2,4.4,4.5,4.4V7.8C17.3,7.3,17,6.9,16.5,6.9z"
        />
        <linearGradient
          id="jira_Vector_3_1_"
          gradientUnits="userSpaceOnUse"
          x1="12.3154"
          y1="14.3387"
          x2="7.5459"
          y2="9.5608"
          gradientTransform="matrix(1 0 0 -1 0 26)"
        >
          <stop
            offset="0.176"
            stopColor="hsl(from hsl(217 100% 58%) h s 32%)"
          />
          <stop offset="1" stopColor="hsl(from hsl(217 100% 58%) h s 51%)" />
        </linearGradient>
        <path
          id="jira_Vector_3"
          fill="url(#jira_Vector_3_1_)"
          d="M11.5,11.8h-10c0,2.4,2,4.4,4.5,4.4h1.8v1.7c0,2.4,2,4.4,4.5,4.4v-9.6
			C12.4,12.1,12,11.8,11.5,11.8z"
        />
      </g>
    </g>
  </svg>
);
